/*
* Custom JS. A bundled copy of jQuery 3.7.1 was removed from this file in Oct 2026 (audit):
* it loaded after the head jQuery, replaced window.$ and dropped the Slick plugin.
* jQuery 3.7.1 is loaded once in layout/theme.liquid <head>.
*/
(function() {
  $(document).ready(function() {
    // "Load More" button on collection pages
    $('.js-load-more').on('click', function() {
      var $this = $(this),
          totalPages = parseInt($('[data-all-pages]').val()),
          currentPage = parseInt($('[data-this-page]').val()),
          datacollurl = $('[data-coll-url]').val();

      if (currentPage >= totalPages) {
        $this.find('[load-more-text]').text('Products Finished').removeClass('hide');
        $this.find('[loader]').addClass('hide');
        return;
      }

      $this.attr('disabled', true);
      $this.find('[load-more-text]').addClass('hide');
      $this.find('[loader]').removeClass('hide');

      var nextUrl = $('[data-next-link]').val();
      var current_page_new = currentPage + 1;
      var next_coll = currentPage + 2;

      $.ajax({
        url: nextUrl,
        type: 'GET',
        dataType: 'html',
        success: function(responseHTML) {
          $('[data-next-link]').val(datacollurl + "?page=" + next_coll);
          $('[data-this-page]').val(current_page_new);
          $('#CollectionLoop').append($(responseHTML).find('#CollectionLoop').html());
        },
        complete: function() {
          if (current_page_new < totalPages) {
            $this.attr('disabled', false);
            $this.find('[load-more-text]').removeClass('hide');
            $this.find('[loader]').addClass('hide');
          }
          if (current_page_new >= totalPages) {
            $this.find('[load-more-text]').text('Products Finished').removeClass('hide');
            $this.find('[loader]').addClass('hide');
          }
        }
      });
    });

    // Initial check for "Load More" button visibility
    var totalPages = parseInt($('[data-all-pages]').val()),
        currentPage = parseInt($('[data-this-page]').val());

    if (currentPage >= totalPages) {
      $('.js-load-more').find('[load-more-text]').text('Products Finished').removeClass('hide');
      $('.js-load-more').find('[loader]').addClass('hide');
      $('.js-load-more').attr('disabled', true);
    }
  });
})();
